import React from 'react';
import '../../utils/assertions.es.js';
import { findChildWithDisplayName } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Tooltip } from '../Tooltip/Tooltip.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { Actions, Content, Media, LeftAction, Card, Container, Title, InfoIcon, Description } from './styled.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AssetCardComponent = forwardRef((props, ref) => {
  const _a = props, {
    icon: IconComponent,
    title,
    size = "lg",
    isDisabled = false,
    error,
    children,
    variant = "outline"
  } = _a, rest = __objRest(_a, [
    "icon",
    "title",
    "size",
    "isDisabled",
    "error",
    "children",
    "variant"
  ]);
  const actions = findChildWithDisplayName(children, Actions.displayName);
  const content = findChildWithDisplayName(children, Content.displayName);
  const media = findChildWithDisplayName(children, Media.displayName);
  const leftAction = findChildWithDisplayName(children, LeftAction.displayName);
  return /* @__PURE__ */ React.createElement(Card, __spreadProps(__spreadValues({
    size,
    error,
    isDisabled,
    variant
  }, rest), {
    ref
  }), leftAction && /* @__PURE__ */ React.createElement(Container, null, leftAction), /* @__PURE__ */ React.createElement(Container, null, media || IconComponent && /* @__PURE__ */ React.createElement(AssetCard.Media, null, /* @__PURE__ */ React.createElement(IconComponent, {
    size: "lg"
  }))), content || /* @__PURE__ */ React.createElement(AssetCard.Content, null, title && /* @__PURE__ */ React.createElement(Title, null, title)), !isDisabled && /* @__PURE__ */ React.createElement(Container, {
    alignItems: "center",
    ml: "auto"
  }, error && /* @__PURE__ */ React.createElement(Tooltip, {
    position: "top",
    content: error
  }, /* @__PURE__ */ React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ React.createElement(InfoIcon, {
    error
  }))), actions));
});
AssetCardComponent.displayName = "AssetCard";
const AssetCard = Object.assign(AssetCardComponent, {
  Content: Content,
  Media: Media,
  Actions: Actions,
  Title: Title,
  Description: Description,
  LeftAction: LeftAction
});

export { AssetCard };
//# sourceMappingURL=AssetCard.es.js.map
